import rawMap from './node-readiness.json';

export type NodeReadiness = 'ready' | 'testing' | 'in_dev' | 'experimental';

const VALID: ReadonlySet<string> = new Set(['ready', 'testing', 'in_dev', 'experimental']);

function coerce(v: unknown): NodeReadiness {
	if (typeof v === 'string' && VALID.has(v)) return v as NodeReadiness;
	return 'in_dev';
}

const map = rawMap as Record<string, string>;

export function getReadinessForPaletteKey(paletteKey: string): NodeReadiness {
	return coerce(map[paletteKey]);
}

export function hasExplicitReadiness(paletteKey: string): boolean {
	return Object.prototype.hasOwnProperty.call(map, paletteKey) && VALID.has(map[paletteKey]);
}

export type ReadinessDisplay = {
	id: NodeReadiness;
	shortLabel: string;
	title: string;
};

export function getReadinessDisplay(readiness: NodeReadiness): ReadinessDisplay {
	switch (readiness) {
		case 'testing':
			return {
				id: readiness,
				shortLabel: 'TEST',
				title: 'Ready for testing',
			};
		case 'in_dev':
			return {
				id: readiness,
				shortLabel: 'DEV',
				title: 'In development',
			};
		case 'experimental':
			return {
				id: readiness,
				shortLabel: 'EXP',
				title: 'Experimental',
			};
		default:
			return {
				id: 'ready',
				shortLabel: 'READY',
				title: 'Ready',
			};
	}
}
